import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webinar_card_icon_speaker_close",
  "use": "webinar_card_icon_speaker_close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"webinar_card_icon_speaker_close\"><path d=\"M14.778 5.23a.755.755 0 0 0-1.07 0L10 8.93 6.291 5.223a.755.755 0 1 0-1.07 1.07L8.932 10l-3.71 3.709a.755.755 0 1 0 1.07 1.07L10 11.068l3.709 3.71a.755.755 0 1 0 1.07-1.07L11.068 10l3.71-3.709a.76.76 0 0 0 0-1.062Z\" fill=\"#fff\" stroke=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol